module.exports = __webpack_public_path__ + "media/images/flags/16/Benin-501865aed0147cfb62d20aac3eb07b48.png";